"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLoading = exports.setList = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var vehicle_model_1 = require("../models/vehicle.model");
var vehicleSlice = (0, toolkit_1.createSlice)({
    name: 'vehicles',
    initialState: (0, vehicle_model_1.vehiclesListFactory)(),
    reducers: {
        setList: function (state, action) {
            state.data = action.payload;
        },
        setLoading: function (state, action) {
            state.loading = action.payload;
        },
    },
});
var actions = vehicleSlice.actions, reducer = vehicleSlice.reducer;
exports.setList = actions.setList, exports.setLoading = actions.setLoading;
exports.default = reducer;
